import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AjaxContext, AppContext } from 'commons-ui';
import { IPaymentNotificationTemplate, listPageName, updateUri } from '../../utils/constants';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const location = useLocation();
	const { postData } = useContext(AjaxContext);
	const {
		app: { appName },
		showAlert
	} = useContext(AppContext);

	const goToListPage = () => {
		history.push({
			pathname: listPageName
		});
	};

	const getEditForData = () => {
		const editData: IPaymentNotificationTemplate = _get(location?.state, 'rowData', {});
		if (editData) {
			return {
				_id: editData?._id,
				delink: editData?.extra?.delink || false,
				isPGError: editData?.extra?.isPGError || false,
				instantFailure: editData?.extra?.instantFailure || false,
				userText: editData?.userText || '',
				isActive: editData?.isActive,
				smsMessage: editData?.smsMessage || '',
				title: editData?.title || '',
				extra: editData?.extra || {},
				userFailureMessage: editData?.userFailureMessage || ''
			};
		}
		goToListPage();
		return {};
	};

	const handleFormSubmit = async (submittedData: IPaymentNotificationTemplate) => {
		try {
			const body: IPaymentNotificationTemplate = { ...submittedData };
			if (!body.userFailureMessage) {
				delete body.userFailureMessage;
			}
			body.extra.delink = submittedData?.delink;
			body.extra.isPGError = submittedData?.isPGError;
			body.extra.instantFailure = submittedData?.instantFailure;
			delete body?.delink;
			delete body?.isPGError;
			delete body?.instantFailure;

			const response = await postData({
				endpoint: updateUri,
				queryParams: {
					appName
				},
				body
			});
			const err: boolean = response?.data && response?.data?.success;
			if (!err) {
				showAlert(`${response?.data?.error}`, { type: 'error' });
			} else {
				showAlert('Record updated');
				goToListPage();
			}
		} catch (error) {
			showAlert(`Error: Payment PG Failure update failed, please try again.`, { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormCancel = () => {
		goToListPage();
	};

	return { showLoader, handleFormSubmit, handleFormCancel, setShowLoader, data: getEditForData() };
};
export default useEdit;
